import { useEffect } from 'react';
import { useGetSurcharges } from 'queries';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared';
import { SurchargeSelectProps } from '../types';

export const SurchargesSelect = ({
  setSelectedSurcharge
}: SurchargeSelectProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'surchargeRelations' });
  const { control, watch } = useFormContext();
  const { data: options } = useGetSurcharges();

  const surchargeCode = watch('surchargeCode');
  const selectedSurcharge = options?.find(
    (option) => option.value === surchargeCode
  );

  useEffect(() => {
    selectedSurcharge && setSelectedSurcharge(selectedSurcharge);
  }, [options, selectedSurcharge]);

  return (
    <ControlledSelect
      variant="outlined"
      control={control}
      label={t('surchargeName')}
      name="surchargeCode"
      options={options ?? []}
    />
  );
};
